import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GetActiveScalesApi } from "../../../api/GetActiveScalesApi";
import GetScaleUnitsByScaleApi from "../../../api/GetScaleUnitsByScaleApi";
import CreateKpiApi from "../../../api/kpis/CreateKpiApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

function AddKpiModal(props) {
  const [submit, setSubmit] = useState(false);
  const [scales, setScales] = useState([]);
  const [scaleUnits, setScaleUnits] = useState([]);
  const [percentage, setPercentage] = useState(false);
  const [addScaleUnit, setAddScaleUnit] = useState(false);
  const [form] = Form.useForm();
  let curLocation = useLocation();

  function handleCancel() {
    setSubmit(false);
    setScales([]);
    setScaleUnits([]);
    setPercentage(false);
    setAddScaleUnit(false);
    form.resetFields();
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getActiveScales();
    }
  }, [props.visible]);

  async function getActiveScales() {
    const apiResponse = await GetActiveScalesApi();
    if (apiResponse.success) {
      setScales(apiResponse.data);
    }
  }

  async function selectScale(value) {
    setScaleUnits([]);
    let addUnit = "";
    scales.forEach((scale) => {
      if (scale.id === value) {
        if (scale.name === "Number") {
          setAddScaleUnit(false);
          setPercentage(false);
        } else if (scale.name === "Percentage") {
          setAddScaleUnit(false);
          setPercentage(true);
        } else {
          setAddScaleUnit(true);
          setPercentage(false);
          addUnit = "add";
        }
      }
    });
    if (addUnit === "add") {
      const apiResponse = await GetScaleUnitsByScaleApi(value);
      if (apiResponse.message === "success") {
        setScaleUnits(apiResponse.scaleUnits);
      }
      apiResponse.scaleUnits?.forEach((unit) => {
        if (unit.default) {
          form.setFields([
            {
              name: "unitScale",
              value: unit.id,
            },
          ]);
        }
      });
    }
  }

  async function onFinish(values) {
    setSubmit(true);
    let path = curLocation.pathname;
    let id = path.split("/top-plans/");
    const apiResponse = await CreateKpiApi(
      props.planId ? props.planId : id[1],
      values.KPI,
      values.target,
      values.targetScale,
      addScaleUnit ? values.unitScale || null : null
    );
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", `KPI created`);
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add KPI. Try again later."
      );
    }
    handleCancel();
  }

  const unitSelector = (
    <Form.Item name="unitScale" noStyle>
      <Select style={{ width: 100 }}>
        {scaleUnits.map((unit) => {
          return (
            <Option key={unit.id} value={unit.id}>
              {unit.abbreviation}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );

  return (
    <>
      <Modal
        title="Add KPI"
        visible={props.visible}
        onCancel={() => handleCancel()}
        footer={null}
        destroyOnClose={true}
      >
        <Form
          name="addKpi"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
          form={form}
        >
          <Form.Item
            label="KPI*"
            name="KPI"
            rules={[
              {
                required: true,
                message: "Please enter a KPI!",
              },
            ]}
          >
            <Input placeholder="KPI" />
          </Form.Item>

          <Form.Item
            label="Target scale*"
            name="targetScale"
            rules={[
              {
                required: true,
                message: "Please select a target scale!",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select a scale"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={(value) => selectScale(value)}
            >
              {scales.map((scale) => {
                return (
                  <Option key={scale.id} value={scale.id}>
                    {scale.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="Target*"
            name="target"
            rules={[
              {
                required: true,
                message: "Please enter target!",
              },
            ]}
          >
            <InputNumber
              min={0}
              addonAfter={addScaleUnit ? unitSelector : percentage && "%"}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <div className=" flex justify-end">
              <Button className="mr-3 w-28" onClick={() => handleCancel()}>
                Cancel
              </Button>
              <Button
                className="btn w-28"
                type="primary"
                htmlType={submit && "submit"}
                disabled={submit}
              >
                {submit ? (
                  <Spin
                    size="small"
                    indicator={
                      <LoadingOutlined style={{ color: "#fff" }} spin />
                    }
                  />
                ) : (
                  `Add`
                )}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default AddKpiModal;
